module.exports = __webpack_public_path__ + "static/media/Fluid Mechanics.02cead4d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MECH/Fluid Mechanics.pdf
// module id = 137
// module chunks = 0